/**
 * Legacy module name — kept because plenty of files still import from
 * "./lib/telegram". The actual storage backend is now Backblaze B2 (proxied
 * through the worker). The exported helpers are storage-agnostic.
 */

export function b2ProxyUrl(key) {
  if (!key) throw new Error("b2 key not specified");
  return `/api/b2/file?key=${encodeURIComponent(key)}`;
}

/**
 * Same-origin URL to fetch the bytes of a manifest file entry. Today every
 * entry should have `storage: "b2"`; the conditional is kept defensively
 * for any stragglers from before the B2 migration.
 */
export function getFileUrl(file) {
  if (file?.storage === "b2" && file?.b2Key) return b2ProxyUrl(file.b2Key);
  throw new Error(`No storage backend for file ${file?.id || "?"}`);
}
